/* حكاية سندس — reveal on scroll (sections/sondos-story-*.liquid).
   Content is visible without this file. It only adds `.sst-motion` once it
   knows which blocks are already on screen (those are marked in first), so
   nothing that is visible ever blinks out. Skipped in the Theme Editor, with
   reduced motion, and where IntersectionObserver is missing. */
(function () {
  if (window.__sstReveal) return;
  window.__sstReveal = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = document.querySelectorAll('[data-sst-reveal]');
  if (!els.length) return;

  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('is-in');
          io.unobserve(entries[i].target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.01 }
  );

  var limit = window.innerHeight * 0.92;
  for (var j = 0; j < els.length; j++) {
    var top = els[j].getBoundingClientRect().top;
    if (top < limit) {
      els[j].classList.add('is-in');
    } else {
      io.observe(els[j]);
    }
  }
  document.documentElement.classList.add('sst-motion');
})();

/* Story loops (sections/sondos-story-flow.liquid): muted clips of the store's
   own footage. No src until near the viewport; paused when out of it; never
   loaded with reduced motion or Save-Data (the poster <img> stays). The clip
   fades in only once it is actually playing, so a slow or blocked autoplay
   (iOS Low Power Mode) simply leaves the picture. */
(function () {
  var vids = document.querySelectorAll('video[data-sst-video]');
  if (!vids.length || !('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (navigator.connection && navigator.connection.saveData) return;
  var io = new IntersectionObserver(
    function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var v = entries[i].target;
        if (entries[i].isIntersecting) {
          if (!v.getAttribute('src')) v.setAttribute('src', v.getAttribute('data-src'));
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      }
    },
    { rootMargin: '160px 0px', threshold: 0.2 }
  );
  for (var j = 0; j < vids.length; j++) {
    vids[j].addEventListener('playing', function () { this.classList.add('is-playing'); });
    io.observe(vids[j]);
  }
})();
